import FeatureIdeaService from './FeatureIdeaService.js';

const service = new FeatureIdeaService();

export default {
  key: 'featureIdea',
  namespaced: true,
  state: {},
  actions: {
    dismiss({commit}, payload = {}) {
      return service.dismiss(payload);
    },
    prompt({commit}, payload = {}) {
      return service.prompt(payload);
    },
    store({commit}, payload = {}) {
      return service.store(payload);
    },
    viewed({commit}, payload = {}) {
      return service.viewed(payload);
    },
    vote({commit}, payload = {}) {
      return service.vote(payload.id, payload);
    },
  },
  mutations: {},
};
